import errorCodesMap from "../constants/errorCodesMap";
import { T } from "./translations";

export default (code) => errorCodesMap?.[code] || T.unknownError
